import React from "react";

export function useInputChangeNumberOnly(
  initialValue: string,
  allowEmpty?: boolean,
) {
  const [value, setValue] = React.useState<string>(initialValue);

  const changeValueHandler = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    const regexp = /^((\d+)([.,])?(\d+)?)$/gi;
    const start0 = /^0\d.*$/gi;

    if (e.target.value) {
      if (start0.test(e.target.value)) {
        setValue(e.target.value.slice(1));
      } else {
        if (regexp.test(e.target.value)) {
          setValue(e.target.value);
        }
      }
    } else {
      setValue(allowEmpty ? "" : "0");
    }
  };

  return {
    value,
    setValue,
    changeValueHandler,
  };
}
